import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full h-screen overflow-hidden" data-id="element-178">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0" data-id="element-179">
        <img src="https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?q=80&w=2400&auto=format&fit=crop" alt="Luxury sports car" className="w-full h-full object-cover" data-id="element-180" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/90" data-id="element-181" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center px-6" data-id="element-182">
        <div className="max-w-5xl text-center" data-id="element-183">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          ease: [0.22, 1, 0.36, 1]
        }} className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight" data-id="element-184">
            Experience Automotive
            <span className="block text-[var(--color-gold)] mt-2" data-id="element-185">
              Excellence
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: [0.22, 1, 0.36, 1]
        }} className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-186">
            Discover our curated collection of the world's most prestigious
            automobiles. Where craftsmanship meets performance.
          </motion.p>

          <motion.button initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="group inline-flex items-center gap-2 bg-[var(--color-gold)] text-black px-8 py-4 text-lg font-medium hover:bg-[var(--color-gold-light)] transition-all duration-300 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)]" aria-label="Explore our collection of luxury vehicles" data-id="element-187">
            Explore Collection
            <ChevronRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-188" />
          </motion.button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 0.8
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2" data-id="element-189">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="w-6 h-10 border-2 border-[var(--color-gold)] rounded-full flex items-start justify-center p-2" data-id="element-190">
          <div className="w-1 h-2 bg-[var(--color-gold)] rounded-full" data-id="element-191" />
        </motion.div>
      </motion.div>
    </section>;
}